export const LOADING_MESSAGE = '请稍等...';
export const SET_IS_REQUEST_STATUS = 'SET_IS_REQUEST_STATUS';
export const SET_IS_REFERAL_LIST_LOADING = 'SET_IS_REFERAL_LIST_LOADING';
export const GET_REFERAL_LIST_SUCCESS = 'GET_REFERAL_LIST_SUCCESS';
export const GET_QA_BULLET_TAGS_SUCCESS = 'GET_QA_BULLET_TAGS_SUCCESS';
export const GET_QA_QUESTION_ASK_TAGS_SUCCESS = 'GET_QA_QUESTION_ASK_TAGS_SUCCESS';
export const SET_SELECTED_TAG_ID = 'SET_SELECTED_TAG_ID';
export const SET_SELECTED_SUBTAG_ID = 'SET_SELECTED_SUBTAG_ID';
export const GET_QA_CPA_INFO_SUCCESS = 'GET_QA_CPA_INFO_SUCCESS';
export const DO_QUESTION_NEW_SUCCESS = 'DO_QUESTION_NEW_SUCCESS';
export const DO_ANSWER_NEW_SUCCESS = 'DO_ANSWER_NEW_SUCCESS';
export const CLEAR_QA_STATE = 'CLEAR_QA_STATE';
